import { render, staticRenderFns } from "./RichTextEditor.vue?vue&type=template&id=840f0336&scoped=true"
import script from "./RichTextEditor.vue?vue&type=script&lang=ts"
export * from "./RichTextEditor.vue?vue&type=script&lang=ts"
import style0 from "./RichTextEditor.vue?vue&type=style&index=0&id=840f0336&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "840f0336",
  null
  
)

export default component.exports